import React from 'react';
import DatePicker from 'react-datepicker';
import {
    parseToDate, dateToDatetimeLocal,
    parseDateString, dateToDateString,
    parseMonthString, dateToMonthString,
    parseTimeString, dateToTimeString,
    getDateFnsLocale
} from '../utils/timestampUtils';

interface DateTimePickerProps {
    mode: 'datetime' | 'date' | 'time' | 'month';
    value: string | null | undefined;
    onChange: (value: string) => void;
    className?: string;
    disabled?: boolean;
    isClearable?: boolean;
    onFocus?: (e: React.FocusEvent) => void;
    autoComplete?: string;
}

const config = {
    datetime: {
        parse: parseToDate,
        format: dateToDatetimeLocal,
        dateFormat: 'dd.MM.yyyy HH:mm',
        showTimeSelect: true,
        showTimeSelectOnly: false,
        timeFormat: 'HH:mm',
    },
    date: {
        parse: parseDateString,
        format: dateToDateString,
        dateFormat: 'dd.MM.yyyy',
        showTimeSelect: false,
        showTimeSelectOnly: false,
        timeFormat: undefined,
    },
    month: {
        parse: parseMonthString,
        format: dateToMonthString,
        dateFormat: 'LLLL yyyy', // localized standalone month name, e.g. "august 2026"
        showTimeSelect: false,
        showTimeSelectOnly: false,
        timeFormat: undefined,
    },
    time: {
        parse: parseTimeString,
        format: dateToTimeString,
        dateFormat: 'HH:mm',
        showTimeSelect: true,
        showTimeSelectOnly: true,
        timeFormat: 'HH:mm',
    },
};

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
    mode,
    value,
    onChange,
    className = 'form-control',
    disabled = false,
    isClearable = false,
    onFocus,
    autoComplete = 'off',
}) => {
    const c = config[mode];

    return (
        <DatePicker
            selected={c.parse(value)}
            onChange={(date: Date | null) => onChange(c.format(date))}
            dateFormat={c.dateFormat}
            showTimeSelect={c.showTimeSelect}
            showTimeSelectOnly={c.showTimeSelectOnly}
            timeFormat={c.timeFormat}
            timeIntervals={5}
            showMonthYearPicker={mode === 'month'}
            locale={getDateFnsLocale()}
            className={className}
            disabled={disabled}
            isClearable={isClearable}
            onFocus={onFocus}
            autoComplete={autoComplete}
            portalId="root"
        />
    );
};
